import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import {List, Map} from "immutable";
import {isFloat} from 'validator';
import moment from 'moment';

// Components
import StatusSelector from "../../components/common/StatusSelector";
import Select from "../../components/common/virtualized-select";
import DateInput from '../../components/common/date-input';

// Actions
import {getSalesOrders, cleanSalesOrders} from "../../actions/sales-orders";

class ProjectDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            document_date: moment(),
            description: '',
            key: '',
            order: -1,
            target_total: '',
            target_margin: ''
        }
    }
    componentDidMount() {
        this.setProjectState();
        this.props.getSalesOrders({
            projection: 'order_code',
            deleteVirtuals: true
        });
        this.props.onRef(this);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.project !== prevProps.project) {
            this.setProjectState();
        }
    }

    componentWillUnmount() {
        this.props.onRef(undefined);
    }

    onChangeInput = (inputName, inputValue) => {
        this.setState({
            [inputName]: inputValue
        }, this.validateProject);
    };
    validateProject = () => {
        if (
            moment(this.state.document_date).isValid() &&
            this.state.project_code !== '' &&
            this.state.name !== '' &&
            this.state.target_margin !== ''
        ) {
            this.props.canSubmit(true);
        }
        else {
            this.props.canSubmit(false);
        }
    };

    setProjectState = () => {
        this.setState({
            document_date: this.props.project.get('document_date'),
            name: this.props.project.get('name') || '',
            description: this.props.project.get('description') || '',
            key: this.props.project.get('key') || '',
            order: this.props.project.getIn(['order', '_id']) || -1,
            target_total: this.props.project.getIn(['statistics', 'target_total']) || '',
            target_margin: this.props.project.getIn(['statistics', 'target_margin']) || ''
        });
    };

    updateProject = () => {
        this.props.updateProject(this.props.project.get('_id'), {
            document_date: this.state.document_date,
            name: this.state.name,
            description: this.state.description,
            key: this.state.key,
            ...(this.state.order !== -1) ? { order: this.state.order } : '',
            statistics: {
                target_total: this.state.target_total,
                target_margin: this.state.target_margin
            }
        });
    };

    render() {
        let statusColor = '', statusText = '';

        switch (this.props.project.get('status')) {
            case 'active':
                statusColor = 'primary';
                statusText = 'Activo';
                break;
            case 'inactive':
                statusColor = 'danger';
                statusText = 'Inactivo';
                break;
            default:
                break;
        }

        return (
            <div className="panel-body">
                <div className="row">
                    <div className="col-3">
                        <div className="form-group">
                            <label>Código de proyecto *</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.props.project.get('project_code')}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="form-group">
                            <label>Fecha de proyecto *</label>
                            {this.props.mode === 'view' ? (
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.document_date ? moment(this.state.document_date).format('DD/MM/YYYY') : ""}
                                    disabled={true}
                                />
                            ) : (
                                <DateInput
                                    onChange={(selectedDate) => {
                                        this.setState({
                                            document_date: selectedDate
                                        }, this.validateProject);
                                    }}
                                    value={this.state.document_date ? moment(this.state.document_date): moment()}
                                    inputWrapperStyle={{height: 40}}
                                    inputStyle={{height: 37, borderRadius: 0, border: '1px solid #ccc'}}
                                    iconStyle={{top: 9, right: 12}}
                                />
                            )}
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="form-group">
                            <label>Nombre de proyecto *</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.name}
                                onChange={ (event) => this.onChangeInput('name', event.target.value) }
                                disabled={this.props.mode === 'view'}
                            />
                        </div>
                    </div>
                    <div className="col-3 ml-auto">
                        <label>Estado</label>
                        { this.props.mode === 'view'
                            ? <div className="row">
                                <div className="col-6">
                                    <span className={ 'status-label label-' + statusColor } >{ statusText }</span>
                                </div>
                                <div className="col-auto d-flex align-items-center" style={{ paddingLeft: 0 }} >
                                    <StatusSelector
                                        statusObject={this.props.project}
                                        statusOptions={['active', 'inactive']}
                                        changeStatus={this.props.changeProjectStatus}
                                    />
                                </div>
                            </div>
                            : <div className="row">
                                <div className="col-6">
                                    <span className={ 'status-label label-' + statusColor } >{ statusText }</span>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="form-group">
                            <label>Descripción</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.description}
                                onChange={ (event) => this.onChangeInput('description', event.target.value) }
                                disabled={this.props.mode === 'view'}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-3">
                        <div className="form-group">
                            <label>Tecla</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.key}
                                onChange={(event) => this.onChangeInput('key', event.target.value)}
                                disabled={this.props.mode === 'view'}
                            />
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="form-group">
                            <label>Pedido de venta asociado</label>
                            <Select
                                className="virtualized-select"
                                options={this.props.salesOrders.toJS()}
                                value={this.state.order}
                                labelKey="order_code"
                                valueKey="_id"
                                matchProp="order_code"
                                multi={false}
                                searchable={true}
                                clearable={false}
                                removeSelected={false}
                                disabled={this.props.mode === 'view'}
                                onChange={(selectedValue) => {
                                    if (selectedValue) {
                                        this.onChangeInput('order', selectedValue._id)
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
                <h4>Valores objetivo</h4>
                <div className="row">
                    <div className="col-3">
                        <div className="form-group">
                            <label>Importe total objetivo</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.target_total}
                                onChange={ (event) => {
                                    const target_total = event.target.value;
                                    if (isFloat(target_total) || target_total === '') {
                                        this.onChangeInput('target_total', target_total);
                                    }
                                }}
                                disabled={this.props.mode === 'view'}
                            />
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="form-group">
                            <label>Margen objetivo (%)</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.target_margin}
                                onChange={ (event) => {
                                    let target_margin = event.target.value;
                                    if (target_margin === '') target_margin = '0';
                                    if (isFloat(target_margin)) {
                                        this.onChangeInput('target_margin', target_margin);
                                    }
                                }}
                                disabled={this.props.mode === 'view'}
                            />
                        </div>
                    </div>
                </div>
                <h4>Estadísticas</h4>
                <div className="row">
                    <div className="col-3">
                        <label>Coste de materiales (€)</label>
                        <input
                            className="form-control"
                            type="text"
                            value={this.props.project.getIn(['statistics', 'material_costs'])}
                            disabled={true}
                        />
                    </div>
                    <div className="col-3">
                        <label>Coste de mano de obra (€)</label>
                        <input
                            className="form-control"
                            type="text"
                            value={this.props.project.getIn(['statistics', 'labour_costs'])}
                            disabled={true}
                        />
                    </div>
                    <div className="col-3">
                        <label>Importe total actual (€)</label>
                        <input
                            className="form-control"
                            type="text"
                            value={this.props.project.getIn(['statistics', 'current_total'])}
                            disabled={true}
                        />
                    </div>
                    <div className="col-3">
                        <label>Margen actual (%)</label>
                        <input
                            className="form-control"
                            type="text"
                            value={this.props.project.getIn(['statistics', 'current_margin'])}
                            disabled={true}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    // Reducers
    const salesOrdersReducer = state.salesOrders;

    // SalesOrders
    let salesOrders = salesOrdersReducer.get('payload') || List([]);
    if (!(salesOrders instanceof List)) salesOrders = List([]);
    salesOrders = salesOrders.insert(0, Map({
        _id: -1,
        order_code: 'Selecciona un pedido de venta'
    }));

    return {
        salesOrders
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSalesOrders: (query) => dispatch(getSalesOrders(query)),
        cleanSalesOrders: () => dispatch(cleanSalesOrders())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectDetails);



// WEBPACK FOOTER //
// ./src/containers/projects/ProjectDetail.js